import React from 'react';
import ProductCard from './ProductCard';
import { useSiteContent } from '@/lib/content/SiteContentContext';

interface Product {
  id: number;
  name: string;
  price: number;
  scentType: string;
  image: string;
  alt: string;
  topNotes: string[];
  heartNotes: string[];
  baseNotes: string[];
  sizes: number[];
  description: string;
  isFastMoving: boolean;
  isBestSelling: boolean;
  stock: number | null;
  offerDiscount?: number;
  gender?: string;
  displayPrice?: number;
  displayCurrency?: string;
}

interface ProductGridProps {
  products: Product[];
}

const ProductGrid: React.FC<ProductGridProps> = ({ products }) => {
  const emptyTitle = useSiteContent('shop_empty_title', 'No perfumes found');
  const emptySubtitle = useSiteContent('shop_empty_subtitle', 'Try adjusting your search or filters to find what you\'re looking for');

  if (products.length === 0) {
    return (
      <div data-component-id="src/app/shop-catalog/components/ProductGrid.tsx:36:6" data-component-path="src/app/shop-catalog/components/ProductGrid.tsx" data-component-line="36" data-component-end-line="43" data-component-file="ProductGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20min-h-%5B400px%5D%20flex-col%20items-center%20justify-center%20rounded-lg%20bg-muted%20p-12%20text-center%22%7D" className="flex min-h-[400px] flex-col items-center justify-center rounded-lg bg-muted p-12 text-center">
        <p data-component-id="src/app/shop-catalog/components/ProductGrid.tsx:37:8" data-component-path="src/app/shop-catalog/components/ProductGrid.tsx" data-component-line="37" data-component-end-line="39" data-component-file="ProductGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mb-2%20font-heading%20text-2xl%20font-semibold%20text-text-primary%22%7D" className="mb-2 font-heading text-2xl font-semibold text-text-primary">
          {emptyTitle}
        </p>
        <p data-component-id="src/app/shop-catalog/components/ProductGrid.tsx:40:8" data-component-path="src/app/shop-catalog/components/ProductGrid.tsx" data-component-line="40" data-component-end-line="42" data-component-file="ProductGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-base%20text-text-secondary%22%7D" className="font-body text-base text-text-secondary">
          {emptySubtitle}
        </p>
      </div>
    );
  }

  return (
    <div data-component-id="src/app/shop-catalog/components/ProductGrid.tsx:48:4" data-component-path="src/app/shop-catalog/components/ProductGrid.tsx" data-component-line="48" data-component-end-line="67" data-component-file="ProductGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20gap-6%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20xl%3Agrid-cols-4%22%7D" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {products.map((product) => (
        <ProductCard data-component-id="src/app/shop-catalog/components/ProductGrid.tsx:50:8" data-component-path="src/app/shop-catalog/components/ProductGrid.tsx" data-component-line="50" data-component-end-line="65" data-component-file="ProductGrid.tsx" data-component-name="ProductCard" data-component-content="%7B%22elementName%22%3A%22ProductCard%22%7D"
          key={product.id}
          id={product.id}
          name={product.name}
          price={product.price}
          scentType={product.scentType}
          image={product.image}
          alt={product.alt}
          topNotes={product.topNotes}
          badge={product.isFastMoving ? 'fast_moving' : product.isBestSelling ? 'best_selling' : undefined}
          stock={product.stock}
          offerDiscount={product.offerDiscount}
          gender={product.gender}
          displayPrice={product.displayPrice}
          displayCurrency={product.displayCurrency}
        />
      ))}
    </div>
  );
};

export default ProductGrid;